import React, { useState } from 'react';

import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Dialog } from '../../../components/layouts';
import { Track } from '../../../weborder/analytics';
import * as Api from '../../../weborder/Api';
import * as Basket from '../../../weborder/BasketControl';
import { MenuDialogAddControls, MenuDialogItemDetails } from '../components';

type Props = {
  currency: Api.Currency;
  item: Api.MenuItem;
  languageCode: string;
  menuId: number;
  onAddItem: (payload: Basket.Item) => void;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  showDialog: boolean;
  translate: any;
  vrId: number;
};

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    '& .MuiDialogTitle-root': {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
    '& .MuiDialogContent-root': {
      padding: 0,
    },
    '& .fd-text__h2': {
      margin: 0,
    },
  },

  dialogActions: {
    display: 'flex',
    flexFlow: 'row nowrap',
    width: '100%',
  },

  [theme.breakpoints.up('sm')]: {
    dialog: {
      '& .MuiDialog-paperScrollPaper': {
        height: 'calc(100vh - 48px)', // - 48px = 24px padding top and bottom
        maxHeight: '720px',
      },
    },
  },
}));

export function MenuDetailDialog(props: Props): JSX.Element {
  const {
    currency,
    item,
    languageCode,
    menuId,
    onAddItem,
    setShowDialog,
    showDialog,
    translate,
    vrId,
  } = props;

  const classes = useStyles();

  const [quantity, setQuantity] = useState(1);

  const handleAddItem = (count = 1): void => {
    const eventData = {
      amp_itemAddedFrom: 'Menu Area',
      amp_itemCount: count,
      amp_itemName: item.Name,
      amp_itemPrice: item.Price,
      amp_label: 'Item Added to Basket',
      amp_productId: item.MenuItemId.toString(),
      eventLabel: item.Name,
      itemType: 'simple',
      label: 'Add Item To Basket Via Options',
      menuId,
      name: item.Name,
      section: 'Restaurants',
      virtualRestaurantId: vrId,
    };

    Track('Restaurants', 'Add Item To Basket Via Options', eventData);

    onAddItem({
      Count: count,
      Item: item,
      Options: [],
    });

    handleCloseDialog();
  };

  const handleCloseDialog = (): void => {
    setShowDialog(false);
  };

  const dialogItem = {
    Item: item,
    Options: [],
  };
  const totalConfigured = Basket.ItemTotal(dialogItem) * quantity;
  const totalCurrency = Basket.ToCurrency(
    totalConfigured,
    currency,
    languageCode,
  );

  const dialogActions = (
    <MenuDialogAddControls
      itemName={item.Name}
      handleAddItem={(): void => handleAddItem(quantity)}
      quantity={quantity}
      setQuantity={setQuantity}
      totalCurrency={totalCurrency}
      translate={translate}
    />
  );

  return (
    <Dialog
      actions={dialogActions}
      className={classes.dialog}
      dialogName="restaurant-menu-detail"
      onTitleClick={handleCloseDialog}
      open={showDialog}
    >
      <MenuDialogItemDetails
        description={item.Description}
        imageUrl={item.ImageUrl}
        name={item.Name}
      />
    </Dialog>
  );
}
